var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-time"},[_c('span',[_vm._v(_vm._s(_vm.data[_vm.fields.source]))]),_c('span',{staticClass:"delimiter"},[_vm._v("|")]),_c('span',[_vm._v(_vm._s(_vm.$dayjs(_vm.data[_vm.fields.time]).format('YYYY-MM-DD HH:mm')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }